<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="grey lighten-3"
      elevation="1"
      height="50"
    >
      <base-img
        :src="require('@/assets/new-logo.png')"
        class="mr-2 mt-n3"
        contain
        max-width="200"
        width="100%"
      />
      <span class="font-weight-bold primary--text hidden-sm-and-down mb-1"
        >#MantapBerhijrah</span
      >
      <v-spacer />

      <div>
        <v-tabs
          v-model="active_tab"
          class="hidden-sm-and-down"
          optional
          background-color="grey lighten-3"
        >
          <v-tab
            v-for="data in items"
            :key="data.id"
            @click="data.child.length === 0 ? URL(data.id) : ''"
            :ripple="false"
            class="font-weight-bold text-capitalize"
            min-width="96"
            text
          >
            <v-menu
              offset-y
              open-on-hover
              :close-on-content-click="true"
              transition="slide-y-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="secondary" left v-if="data.id === 'login'">
                  mdi-shield-account-variant
                </v-icon>
                <span v-bind="attrs" v-on="on"
                  >{{ data.title }}
                  <v-icon v-if="data.child.length > 0"
                    >mdi-menu-down</v-icon
                  ></span
                >
              </template>
              <v-list v-if="data.child.length > 0" dense class="mt-4">
                <v-list-item
                  v-for="(item, index) in data.child"
                  :key="index"
                  @click="URL(item.id)"
                >
                  <v-list-item-title
                    ><v-icon>{{ item.icon }}</v-icon>
                    {{ item.title }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
        icon
      >
        <v-icon>mdi-apps</v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" @close="drawer = false" />
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer")
  },

  data: () => ({
    drawer: null,
    items: [
      { id: "beranda", title: "Beranda", child: [] },
      {
        id: "tentang",
        title: "Tentang Kami",
        child: [
          {
            id: "tentang-kami",
            title: "Visi Misi Takaful",
            icon: "mdi-bullseye"
          },
          {
            id: "struktur-perusahaan",
            title: "Struktur Takaful",
            icon: "mdi-sitemap"
          },
          {
            id: "struktur-pemegang-saham",
            title: "Struktur Pemegang Saham",
            icon: "mdi-chart-arc"
          },
          {
            id: "sejarah-takaful",
            title: "Sejarah Takaful",
            icon: "mdi-domain"
          },
          {
            id: "produk",
            title: "Produk untuk Anda",
            icon: "mdi-shield-check-outline"
          },
          {
            id: "berita-lainnya",
            title: "Ikuti Berita kami",
            icon: "mdi-newspaper-variant-outline"
          },
          {
            id: "penghargaan-perusahaan",
            title: "Penghargaan",
            icon: "mdi-trophy-outline"
          },
          {
            id: "anggaran-dasar",
            title: "Anggaran Dasar",
            icon: "mdi-file-document-outline"
          },
          {
            id: "perizinan",
            title: "Perizinan",
            icon: "mdi-license"
          }
          // {id: 'laporan-keuangan', title: 'Laporan Keuangan', icon:'mdi-finance'},
          // {id: 'laporan-nonkeuangan', title: 'Laporan Non Keuangan', icon:'mdi-file-document-multiple-outline'},
          // {
          //   id: "kalender-2025",
          //   title: "Kalender Takaful",
          //   icon: "mdi-calendar"
          // }
          // {id: 'mars-takaful', title: 'Mars Takaful Umum', icon:'mdi-music-clef-treble'},
        ]
      },
      {
        id: "hubungan",
        title: "Hubungan Investor",
        child: [
          { id: "prospektus", title: "Prospektus", icon: "mdi-sprout-outline" },
          {
            id: "laporan-tahunan",
            title: "Laporan Tahunan",
            icon: "mdi-file-document-multiple-outline"
          },
          {
            id: "laporan-keuangan",
            title: "Laporan Keuangan",
            icon: "mdi-finance"
          },
          {
            id: "laporan-nonkeuangan",
            title: "Laporan Non Keuangan",
            icon: "mdi-file-document-multiple-outline"
          },
          {
            id: "corporategovernance",
            title: "Tata Kelola Perusahaan",
            icon: "mdi-file-document-multiple-outline"
          },
          {
            id: "informasi",
            title: "Informasi Rapat Umum Pemegang Saham",
            icon: "mdi-account-group-outline"
          },
          {
            id: "informasi-saham",
            title: "Informasi Saham",
            icon: "mdi-hand-coin-outline"
          },
          {
            id: "keterbukaan-informasi",
            title: "Keterbukaan Informasi",
            icon: "mdi-folder-open-outline"
          }
        ]
      },
      {
        id: "layanan",
        title: "Layanan",
        child: [
          {
            id: "pengaduan",
            title: "Pengaduan Peserta",
            icon: "mdi-format-quote-close-outline"
          },
          { id: "procedure", title: "Prosedur dan Cara Bertransaksi", icon: "mdi-handshake-outline" },
          { id: "jaringan", title: "Jaringan", icon: "mdi-store-outline" },
          { id: "marketingexecutive", title: "Marketing Executive", icon: "mdi-account-tie" },
          {
            id: "bengkel-rekanan",
            title: "Bengkel Rekanan",
            icon: "mdi-car-search"
          },
          { id: "faq", title: "FAQ", icon: "mdi-message-question-outline" },
          {
            id: "perbedaan-takaful-dengan-konvensional",
            title: "Perbedaan Takaful dengan Konvensional",
            icon: "mdi-apple-safari"
          }
        ]
      },
      { id: "wbs", title: "Whistle Blowing", child: [] },
      { id: "karir", title: "Karir", child: [] },
      { id: "login", title: "AkunKu", child: [] }
    ],
    ShowMenu: false
  }),
  computed: {
    active_tab() {
      return this.$route.meta.tabs;
    }
  },
  methods: {
    URL(id) {
      if (id !== "") {
        this.$router.push({ name: id }).catch(() => {});
      }
    }
  }
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

  .v-tab
    &::before
      display: none
</style>
